<div class="white px-4 section-header">
  <h3>Facebook Data</h3>
  <p class="grey-text pt-3">Manage your data</p>
</div>

<div class="container-fluid pt-5 pb-5">
  <div class="pt-3 pb-5">
    <!-- <button mdbBtn class="prerec white-text" routerLink="/bluedata">Premium Records</button>
    <button mdbBtn class="stanrec white-text" routerLink="/bluedatastandard">Standard Records</button> -->

    <div *ngIf="bdils" class="mt-4 white">
      <app-bdil-list [bdils]="bdils" (bdilEdited)="onBdilEdit($event)" (bdilDeleted)="onBdilDelete($event)" (bdilSaved)="onBdilSave($event)"></app-bdil-list>
    </div>

    <div *ngIf="isLoading$ | async" class="d-flex justify-content-center align-items-center" style="margin-top: 200px">
      <div class="spinner-grow text-primary" role="status" style="width: 4rem; height: 4rem;">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</div>
